var lx = lx || {};
lx.util = lx.util || {};

lx.util.toggle_visibility = function (id) {
	alert(id);
	var e = document.getElementById(id);
	if(e.style.display == 'none')
		e.style.display = '';
	else
		e.style.display = 'none';
};

lx.util.clickCount = function(pEtyId, pRecId, pURL) {
        apex.server.process("CLICK_COUNT", {
            x01: pEtyId,
            x02: pRecId
        }, {
            dataType: "html",
            success: function(d) {
				$('#uiMapDLink-' + pRecId).text('Downloads: ' + d);
				//window.location.href = pURL;
				//window.open(pURL, '_blank');
            }
        });
    };

lx.util.clickCountImg = function() {
        apex.server.process("CLICK_COUNT", {
            x01: pEtyId,
            x02: pRecId
        }, {
            dataType: "html",
            success: function(d) {
				$('#uiMapDLink-' + pRecId).text('Downloads: ' + d);
				// window.location.href = pURL;
            }
        });
    };
	
/** Function that count occurrences of a substring in a string;
 * @param {String} string               The string
 * @param {String} subString            The sub string to search for
 * @param {Boolean} [allowOverlapping]  Optional. (Default:false)
 *
 * @author Vitim.us https://gist.github.com/victornpb/7736865
 */
lx.util.occurrences = function (string, subString, allowOverlapping) {

    string += "";
    subString += "";
    if (subString.length <= 0) return (string.length + 1);

    var n = 0,
        pos = 0,
        step = allowOverlapping ? 1 : subString.length;

    while (true) {
        pos = string.indexOf(subString, pos);
        if (pos >= 0) {
            ++n;
            pos += step;
        } else break;
    }
    return n;
}

lx.util.hexToRgb = (hex) => {
    var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    hex = hex.replace(shorthandRegex, function(m, r, g, b) {
      return r + r + g + g + b + b;
    });
  
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16)
    } : null;
};

lx.util.luminance = (r, g, b) => {
    var a = [r, g, b].map(function (v) {
      v /= 255;
      return v <= 0.03928
        ? v / 12.92
      : Math.pow( (v + 0.055) / 1.055, 2.4 );
    });
    return a[0] * 0.2126 + a[1] * 0.7152 + a[2] * 0.0722;
};

lx.util.calculateRatio = (bgColor, txtColor) => {
    // read the colors and transform them into rgb format
    const color1 = (txtColor ? txtColor : "#333");
    const color2 = (bgColor ? bgColor : "#FFF");
    const color1rgb = lx.util.hexToRgb(color1);
    const color2rgb = lx.util.hexToRgb(color2);
  
    // calculate the relative luminance
    const color1luminance = lx.util.luminance(color1rgb.r, color1rgb.g, color1rgb.b);
    const color2luminance = lx.util.luminance(color2rgb.r, color2rgb.g, color2rgb.b);
  
    // calculate the color contrast ratio
    const ratio = color1luminance > color2luminance 
    ? ((color2luminance + 0.05) / (color1luminance + 0.05))
    : ((color1luminance + 0.05) / (color2luminance + 0.05));
  
    return ratio;
};

var clickCount = lx.util.clickCount;
var clickCountImg = lx.util.clickCountImg;
var occurrences = lx.util.occurrences;